import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { compose } from "recompose";
import { withSnackbar } from "notistack";

import { Button } from "@material-ui/core";
import { Marker, Popup } from "react-leaflet";

import { IconFtteMarker } from "../icons";
import { EligibilitePro } from "../../../../services";

const MarkersImbFtte = ({
  dsp,
  imbWkt,
  displayMarkerImb,
  setChargementIMBWtk,
  rechercheParSiret,
  enqueueSnackbar,
}) => {
  const [markersImbsFtte, setMarkersImbsFtte] = useState([]);
  const [abortImbsFtteWkt, setAbortImbsFtteWkt] = useState(new AbortController());

  /*
    STATUT IMMEUBLE                     | CODE STATUT
                                        |
    RA : Raccordé                       | RA : Raccordé
    DE : Déployé && MeS < today         | EL : Eligible
    GE : Déployé && MeS > today         | PE : Prochainement Eligible
    CI : Ciblé                          | RD : Raccordable sur demande
    SI : Signé                          | TRR : Travaux dans votre rue
    EC : En cours de déploiement        | TRS : Travaux dans votre secteur
    TRR : Travaux dans votre rue        | ET : En cours d'étude
    TRS : Travaux dans votre secteur    |
    RD : Raccordable sur demande        |
    ET : En cours d'étude               |
  */

  // Récupère les immeubles pour une zone géographique
  const getImmeublesFtteWkt = async (minLatLng, maxLatLng) => {
    setChargementIMBWtk(true);

    abortImbsFtteWkt.abort();
    const abort = new AbortController();
    setAbortImbsFtteWkt(abort);

    EligibilitePro.getSiretZone(minLatLng.lng, minLatLng.lat, maxLatLng.lng, maxLatLng.lat, abort)
      .then(responseImbsFtte => {
        const markersImmeublesFtteTemp = responseImbsFtte.features.map(item => {
          const marker = {
            key: item.properties.siret,
            icon: IconFtteMarker,
            position: [item.geometry.coordinates[1], item.geometry.coordinates[0]],
          };

          return marker;
        });

        setMarkersImbsFtte(markersImmeublesFtteTemp);
        setChargementIMBWtk(false);
      })
      .catch(e => {
        if (e.code !== "ERR_CANCELED") {
          setChargementIMBWtk(false);
          enqueueSnackbar(process.env.ERREUR_SERVEUR, {
            variant: "error",
            autoHideDuration: 6000,
          });
        }
      });
  };

  useEffect(() => {
    if (displayMarkerImb && imbWkt.minLatLng && imbWkt.maxLatLng) {
      getImmeublesFtteWkt(imbWkt.minLatLng, imbWkt.maxLatLng);
    }
  }, [imbWkt]);

  useEffect(() => () => abortImbsFtteWkt.abort(), []);

  return (
    <>
      {displayMarkerImb &&
        markersImbsFtte.length > 0 &&
        markersImbsFtte.map(marker => (
          <Marker key={marker.key} position={marker.position} icon={marker.icon} riseOnHover>
            <Popup maxWidth={260} autoPan={false}>
              <div className="alignCenter fontBold">Siret : {marker.key}</div>
              <div className="alignCenter fontItalic">
                lat : {marker.position[0]}, long : {marker.position[1]}
              </div>
              <br />
              <div className="alignCenter">
                <Button
                  className="markerButtonDetail"
                  onClick={() =>
                    rechercheParSiret(marker.key, marker.position[0], marker.position[1])
                  }
                >
                  Vérifier l&apos;éligibilité
                </Button>
              </div>
            </Popup>
          </Marker>
        ))}
    </>
  );
};

MarkersImbFtte.propTypes = {
  dsp: propTypes.shape({
    logo: propTypes.string,
    codeMarche: propTypes.string,
    codeReseau: propTypes.string,
    libelle: propTypes.string,
    urlSite: propTypes.string,
    urlZonesDeploiement: propTypes.string,
    urlFibreFtth: propTypes.string,
    urlFibreSurDemande: propTypes.string,
    urlFibreFtte: propTypes.string,
    urlChangementAdresse: propTypes.string,
    urlListeOperateur: propTypes.string,
    urlPreparation: propTypes.string,
  }).isRequired,
  imbWkt: propTypes.shape({
    minLatLng: propTypes.shape({
      lat: propTypes.number,
      lng: propTypes.number,
    }),
    maxLatLng: propTypes.shape({
      lat: propTypes.number,
      lng: propTypes.number,
    }),
  }).isRequired,
  displayMarkerImb: propTypes.bool.isRequired,
  setChargementIMBWtk: propTypes.func.isRequired,
  rechercheParSiret: propTypes.func.isRequired,
  enqueueSnackbar: propTypes.func.isRequired,
};

export default compose(withSnackbar)(MarkersImbFtte);
